<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>售后工单商品-列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px">
                <el-row :gutter="10">
                  <el-col>
                    <el-form-item label="输入搜索：">
                      <el-col :span="2">
                        <el-input
                          v-model="form.work_id"
                          placeholder="工单ID"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.order_sn"
                          placeholder="订单号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.tracking_sn"
                          placeholder="运单号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.goods_sn"
                          placeholder="商品货号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.goods_name"
                          placeholder="商品名称"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.update_admin"
                          placeholder="最后处理人"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.policy"
                          placeholder="选择政策类型"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.optionsPolicy"
                            :key="item.key"
                            :label="item.label"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.refund_status"
                          placeholder="用户退款状态"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.optionsRefund"
                            :key="item.key"
                            :label="item.label"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.barter_status"
                          placeholder="换货处理状态"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.optionsBarter"
                            :key="item.key"
                            :label="item.label"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="7">
                    <el-form-item label="收件时间：">
                      <el-date-picker
                        v-model="form.receive_time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7">
                    <el-form-item label="寄件时间：">
                      <el-date-picker
                        v-model="form.delivery_time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7">
                    <el-form-item label-width="125px" label="最后处理时间：">
                      <el-date-picker
                        v-model="form.last_opera_time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <!-- <div style="padding: 0 25px;">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="生成时间：">
                  <el-date-picker v-model="form.pay_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div> -->
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output(1)"
            >面单导出</el-button
          >
          <el-button
            style="margin-left: 10px"
            type="success"
            size="mini"
            @click="output(2)"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="work_id"
              label="工单ID"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="policy_str"
              label="政策类型"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="handle_type_str"
              label="处理类型"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="order_sn"
              label="订单号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="tracking_sn"
              label="运单号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column type="expand" props="goods_sn">
              <template slot-scope="props">
                <el-form
                  ref="form"
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                  label-width="80px"
                >
                  <el-form-item>
                    <img
                      style="width: 130px; height: 130px"
                      :src="props.row.goods_img"
                    />
                  </el-form-item>
                  <el-form-item>
                    {{ props.row.goods_name }}
                  </el-form-item>
                  <el-form-item>
                    {{ props.row.color }} / {{ props.row.size }} *
                    {{ props.row.quantity }}
                  </el-form-item>
                  <el-form-item>
                    <span>{{ props.row.price }}</span>
                  </el-form-item>
                  <el-form-item>
                    <span>{{ props.row.market }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_admin"
              label="发布人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="refund_status_str"
              label="用户退款状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="remark"
              label="售后退款备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="barter_status_str"
              label="换货处理状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="receive_time"
              label="收件时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="update_admin"
              label="最后处理人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="last_opera_time"
              label="最后处理时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="delivery_time"
              label="寄出时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="delivery_tracking_sn"
              label="寄出运单号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {},
      loading: false, // 加载动画是否显示
      url: "/erp/afterSales/lists",
      status: -1,
      curPage: 1,
      loading: false,
      tableLoading: false,
      filterFold: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    output(type) {
      if (type == 1) {
        this.form.output = 1;
      }
      if (type == 2) {
        this.form.output = 0;
        this.form.is_excel = 1;
      }

      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.form.is_excel = 0;
          this.form.output = 0;
          this.$message.error(res.data.msg);
        } else if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row, index) {
      const curRow = this.resData.list[index];
      this.$router.push(`/home/returnandexchangedetail/${curRow.receipt_id}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    selectStatus(key) {
      this.form.status = this.status = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.demo-form-inline .el-form-item {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AfterSalesList.vue